// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2b-3s","content":"styles_content__1j6ZC","tableWrap":"styles_tableWrap__2s7C6"};